@if (modalVisible()) {
  <div class="fixed inset-0 flex justify-center items-center z-50  " [ngStyle]="{
    background: modalService.modalType() === 'confirmation'
      ? 'rgba(39, 43, 52, 0.24)'    
      : 'rgba(6, 48, 87, 0.24)'     
  }" (click)="onClose()" (keydown.enter)="onClose()">
    <div class="bg-white w-[440px] h-auto rounded-[16px] p-[16px] shadow-custom ">
      <div class="flex flex-col items-center justify-center w-full gap-[16px] pt-[20px] ">
      
        @if (modalService.useIcon()) {
          <i [class]="modalService.iconClass()" class="text-6xl"></i>
        } @else {
          <picture>
            <source [srcset]="modalService.imageUrl()" type=".webp">
            <img [ngSrc]="modalService.imageUrl()" alt="Warning icon" class="w-[192px] h-[168px] object-cover" width="192" 
            height="168" loading="lazy">
          </picture>
        }

        <h2 class="w-full  font-bold text-[20px] leading-[24.38px] text-center text-[#0A4E8F]">
          {{ modalService.title() }}
        </h2>

        <p class="w-full  font-medium text-[16px] leading-[24px] text-center text-[#272B34]">
          {{ modalService.message() }}
        </p>

        <div class="flex w-full gap-[8px] pt-[8px] pb-[8px] justify-center">
          @if (modalService.btnCancelar()) {
            <button class="w-[192px] h-[48px] rounded-[16px] px-[16px] py-[12px] bg-white text-center font-semibold text-[#272B34]" (click)="onClose()">
              Cancelar
            </button>
          }

          <button [ngClass]="{
            'bg-[#0A4E8F]': modalService.modalType() !== 'warning',
            'bg-[#FF3030]': modalService.modalType() === 'warning',
            'w-[392px] h-[48px]': modalService.modalType() === 'confirmation',
            'w-[192px] h-[48px]': modalService.modalType() !== 'confirmation'
          }"  class="rounded-[16px] px-[16px] py-[12px] bg-[#0A4E8F] text-white text-center font-semibold" (click)="onConfirmClick()">
            {{ modalService.continueButtonText() }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
